import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { _cs } from '@togglecorp/fujs';
import Button from '../Button/index.js';
import RadioInput from '../RadioInput/index.js';
import { genericMemo } from '../../utils/index.js';
import styles from './styles.css.js';

function Segment(props) {
  const {
    label,
    name,
    onClick,
    value,
    className,
    inputName,
    // eslint-disable-line @typescript-eslint/no-unused-vars
    ...otherProps
  } = props;
  return /*#__PURE__*/React.createElement(Button, _extends({}, otherProps, {
    className: _cs(styles.segment, className),
    name: name,
    onClick: onClick,
    variant: value ? 'primary' : 'secondary'
  }), label);
}

// eslint-disable-next-line @typescript-eslint/ban-types
function SegmentInput(props) {
  const {
    rendererParams,
    listContainerClassName,
    keySelector,
    labelSelector,
    className,
    ...otherProps
  } = props;
  return /*#__PURE__*/React.createElement(RadioInput, _extends({
    className: _cs(className, styles.segmentInput)
  }, otherProps, {
    renderer: Segment,
    rendererParams: rendererParams,
    listContainerClassName: _cs(listContainerClassName, styles.list),
    keySelector: keySelector,
    labelSelector: labelSelector
  }));
}

var index = genericMemo(SegmentInput);

export { index as default };
//# sourceMappingURL=index.js.map
